import { useState, useEffect, useCallback } from 'react';
import { getSentTracks } from '../../api/spotify.api';

// Próximas canciones con cuánto falta para que empiece cada una (etaMs) y si la pidió esta mesa (mine).
// ponytail: asume que nadie salta canciones; el poll de 15 s lo corrige.
export function withEta(nowPlaying, upNext, sent) {
  const pending = new Set(sent.filter((s) => !s.played).map((s) => s.trackUri));
  let eta = nowPlaying ? Math.max(0, nowPlaying.durationMs - nowPlaying.progressMs) : 0;
  return upNext.map((t) => {
    const item = { ...t, etaMs: eta, mine: pending.has(t.uri) };
    eta += t.durationMs;
    return item;
  });
}

export function useSentTracks(roomId) {
  const [sent, setSent]             = useState([]);
  const [nowPlaying, setNowPlaying] = useState(null);
  const [upNext, setUpNext]         = useState([]);
  const [recent, setRecent]         = useState([]);
  const [ready, setReady]           = useState(false);

  const refresh = useCallback(async () => {
    try {
      const data = await getSentTracks(roomId);
      setSent(data.sent);
      setNowPlaying(data.nowPlaying);
      setUpNext(data.upNext);
      setRecent(data.recent);
    } catch {
      /* se reintenta en el próximo poll */
    } finally {
      setReady(true);
    }
  }, [roomId]);

  useEffect(() => {
    refresh();
    const id = setInterval(refresh, 15000);
    return () => clearInterval(id);
  }, [refresh]);

  // mine en la que suena: cualquier enviada de esta mesa (al empezar a sonar puede venir ya played).
  const nowMine = !!nowPlaying && sent.some((s) => s.trackUri === nowPlaying.uri);
  return {
    sent,
    nowPlaying: nowPlaying && { ...nowPlaying, mine: nowMine },
    recent,
    upNext: withEta(nowPlaying, upNext, sent),
    ready,
    refresh,
  };
}
